import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { forkJoin } from 'rxjs';

import { ConfigurationType, CustomTitle, FormCreatorService } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GlobalOptionsComponent } from './global-options/global-options.component';
import { PageOptionsComponent } from './page-options/page-options.component';
import { ControlOptionsComponent } from './control-options/control-options.component';

@Component({
  selector: 'app-form-configuration',
  standalone: true,
  imports: [
    CommonModule, TranslateModule,
    GlobalOptionsComponent, PageOptionsComponent, ControlOptionsComponent,
    CustomTitle
  ],
  templateUrl: './form-configuration.component.html',
  styleUrls: ['./form-configuration.component.scss']
})
export class FormConfigurationComponent implements OnInit {
  

  @ViewChild(GlobalOptionsComponent) globalOptionsComponent !: GlobalOptionsComponent;
  @ViewChild(PageOptionsComponent) pageOptionsComponent !: PageOptionsComponent;
  @ViewChild(ControlOptionsComponent) ControlOptionsComponent !: ControlOptionsComponent;

  private _translations: any = {};

  constructor(public fc: FormCreatorService, private _translate: TranslateService) {
  }

  ngOnInit(): void {
    forkJoin({
      global: this._translate.get('dynamic-form.configuration.global'),
      pagina: this._translate.get('dynamic-form.configuration.pagina'),
      control: this._translate.get('dynamic-form.configuration.control')
    }).subscribe(translations => {
      this._translations = translations;
    });
  }

  //#region Getters
  get Type() {
    return this.fc.ConfigurationSection.type;
  }

  get Page() {
    return this.fc.ConfigurationSection.page;
  }

  get control() {
    return this.fc.ConfigurationSection.control;
  }
  //#endregion Getters

  //#region Menu

  initializeCurrentMenu() {
    switch (this.Type) {
      case ConfigurationType.Global:
        this.globalOptionsComponent.initialize();
        break;
      case ConfigurationType.Page:
        this.pageOptionsComponent.initialize();
        break;
      case ConfigurationType.Control:
        this.ControlOptionsComponent.initialize();
        break;
    }

  }

  //#endregion Menu

  getMenuTitle(): string {
    switch (this.Type) {
      case ConfigurationType.Global:
        return this._translations.global;
      case ConfigurationType.Page:
        return this._translations.pagina + this.Page?.name;
      case ConfigurationType.Control:
        return this._translations.control + this.control?.name;
    }
  }

}
